/**
 * setCookie - 柔軟なオプションでCookieをセット
 * @param {string} name - Cookie名
 * @param {string} value - Cookie値
 * @param {Object} options - { days, maxAge, path, sameSite, secure }
 */
export function setCookie(name, value, options = {}) {
  let cookieStr = `${name}=${encodeURIComponent(value)}`
  const { days, maxAge, path = '/', sameSite, secure } = options
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    cookieStr += `; expires=${date.toUTCString()}`
  }
  if (typeof maxAge !== 'undefined') {
    cookieStr += `; max-age=${maxAge}`
  }
  if (path) {
    cookieStr += `; path=${path}`
  }
  if (sameSite) {
    cookieStr += `; SameSite=${sameSite}`
  }
  if (secure) {
    cookieStr += '; Secure'
  }
  document.cookie = cookieStr
}
export function getCookie(name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

export function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;'
}
